<template>
  <div>
    <el-badge
      :hidden="unreadCount < 1"
      :value="unreadCount"
      :max="10"
      class="item"
    >
      <el-button
        type="warning"
        icon="el-icon-message-solid"
        @click="handleSearch"
        style="margin-left: 15px;"
        circle
        title="消息通知"
      ></el-button>
    </el-badge>
    <el-dialog
      title="消息列表"
      :visible.sync="listDialogVisible"
      width="800px"
      top="50px"
      append-to-body
    >
    <div class="xx-out">
      <div class="xx-list-item" v-for="item in messageList" @click="handleView(item)">
        <el-badge :hidden="item.isOpen == 1" value="未读" class="item">
          <div class="xx-title">{{ item.content }}</div>
          <div class="xx-info">

            <div>时间：{{ item.sendTime | formatDateTime }}</div>
            <div style="margin-left: 30px;">发件人：{{ item.sendName }}</div>
          </div>
          <!-- <el-button type="text" @click="handleView(item)">{{
            item.title ? "点击回执" : "查看详情"
          }}</el-button> -->
          <el-button v-if="item.title" type="success" @click="handleView(item)" size="mini" style="margin-top: 10px;">点击回执</el-button>
          <el-button v-else type="text" @click="handleView(item)">查看详情</el-button>

        </el-badge>
      </div>
      <el-pagination
        v-if="pageTotal > 10"
        background
        layout="prev, pager, next"
        :total="pageTotal"
        @current-change="handlePageChange"
        style="margin-top: 20px;position: sticky;bottom: 0;background-color: #f7f7f7;padding: 10px 0;"
      >
      </el-pagination>
    </div>
    </el-dialog>

    <el-dialog
      title="消息详情"
      :visible.sync="viewDialogVisible"
      width="800px"
      top="50px"
      :show-close="false"
      append-to-body
      :key="message.id"
    >
      <Message
        :message="message"
        @readMessage="readMessage"
        @updateMessageStatus="updateMessageStatus"
      />
      <div slot="footer">
        <el-button @click="viewDialogVisible = false" size="small" icon="el-icon-close">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Message from "./Message.vue";
import { formatDate } from "@/utils/date";
import { getCookie } from "@/utils/support";
import {
  getUnreadCount,
  getMessageList,
  updateMessageStatus,
} from "@/api/message";
export default {
  name: "MessageList",
  components: { Message },
  data() {
    return {
      empId: window.localStorage.getItem("EMPID"),
      //未读消息数量
      unreadCount: 0,
      messageList: [],
      listDialogVisible: false,
      message: {},
      viewDialogVisible: false,
      pageNum: 1,
      pageTotal: 0,
    };
  },
  filters: {
    formatDateTime(time) {
      if (time == null || time === "") {
        return "N/A";
      }
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm");
    },
  },
  methods: {
    handleView(item) {
      this.message = item;
      this.viewDialogVisible = true;
    },
    handleSearch() {
      getMessageList({ pageNum: this.pageNum,empId:this.empId }).then((res) => {
        this.messageList = res.data.list;
        this.pageTotal = res.data.total;
        this.listDialogVisible = true;
      });
    },
    getUnreadCount() {
      getUnreadCount({empId:this.empId})
        .then((res) => {
          this.unreadCount = res.data;
          if(this.unreadCount!=null&&this.unreadCount>0) {
            this.listDialogVisible=true;
            this.handleSearch();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handlePageChange(pageNum) {
      this.pageNum = pageNum;
      this.handleSearch();
    },
    readMessage(id) {
      updateMessageStatus({ id: id, isOpen: 1 }).then((res) => {
        this.getUnreadCount();
        this.handleSearch();
      });
    },
    updateMessageStatus(tagType, tag) {
      updateMessageStatus({
        id: this.message.id,
        tagType: tagType,
        tag: tag,
      }).then((res) => {
        this.message.tagType = tagType;
        this.message.tag = tag;
        this.getUnreadCount();
        this.handleSearch();
        this.$message.success("回执成功！");
      });
    },
  },
  created() {
    this.getUnreadCount();
  },
};
</script>

<style lang="scss" scoped>
.xx-out{
  height: 550px;
  width: 100%;
  overflow-y: auto;
}
.xx-list-item{
  width: 100%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  padding: 20px 0 10px 0;
  .xx-title{
    font-size: 16px;
    color: #191919;
  }
  .xx-info{
    display: flex;
    font-size: 12px;
    color: #666;
    margin-top: 8px;
  }
  &:hover{
    background-color: #f2faff;
  }
}
</style>

<style>
.xx-out .el-badge__content.is-fixed {
  top: auto;
  bottom: 3px;
  right: auto;
  left: 60px;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/MessageList.vue